<template>
  <div class="main">
    <!-- <TopAside /> -->
    <mainContent />
  </div>
</template>

<script>

import mainContent from './component/mainContent';
// import TopAside from './component/top-aside';
export default {
  data () {
    return {};
  },
  components: {
    mainContent,
    // TopAside
  },
  mounted () {
    var stuNumber = JSON.parse(localStorage.getItem("studentsList"))[0].student_phonenumber;
    if (localStorage.getItem("student_phonenumber") == stuNumber) {
      this.$router.replace("/curriculumAreas");
    } else {
      localStorage.setItem("student_phonenumber", stuNumber);
      this.$router.replace("/detection");
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  background: url("../../../static/images/bg.png");
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/page/layout/index.vue